import React from 'react';
import InputDateTime from "../../../../components/input/input-datetime.jsx";
import SelectComponent from "../../../../components/select/select-component.jsx";
import useReportFiltersFetch from "../../../../hooks/use-report-filters-fetch.js";
import InputCheckbox from "../../../../components/input/input-checkbox.jsx";
import {minMenuHeight} from "../../../../components/reports/report-menu/menu.jsx";

const Filters = ({setFilters, filters}) => {
    const {boResponsible, boResponsibleReason, boStatus} = useReportFiltersFetch({fetchBOResponsible: true, fetchBOResponsibleReason: true, fetchBOStatus: true})

    return (
        <>
            <div className={`mb-2 ${minMenuHeight}`}>
                <form className={'space-y-4'}>

                     <InputDateTime
                         id="dtStart"
                         label="Data/hora inicial *"
                         selected={filters.dtStart}
                         onChange={(date) => setFilters(prev => ({...prev, dtStart: date}))}
                         classNameWrapper={"w-full"}
                         dateFormat="LL"
                     />

                     <InputDateTime
                         id="dtEnd"
                         label="Data/hora final *"
                         selected={filters.dtEnd}
                         onChange={(date) => setFilters(prev => ({...prev, dtEnd: date}))}
                         classNameWrapper={"w-full"}
                         dateFormat="LL"
                     />

                    <SelectComponent
                        label='Responsável'
                        isMulti={true}
                        wrapValues={true}
                        options={boResponsible}
                        value={filters.responsible}
                        onChange={(value) => setFilters(prev => ({...prev, responsible: value}))}
                        instanceId="responsible"
                        classNameWrapper={"w-full"}
                    />

                    <SelectComponent
                        label='Natureza'
                        isMulti={true}
                        wrapValues={true}
                        options={boResponsibleReason}
                        value={filters.reason}
                        onChange={(value) => setFilters(prev => ({...prev, reason: value}))}
                        instanceId="reason"
                        classNameWrapper={"w-full"}
                    />

                    <SelectComponent
                        label='Status'
                        isMulti={true}
                        wrapValues={true}
                        options={boStatus}
                        value={filters.status}
                        onChange={(value) => setFilters(prev => ({...prev, status: value}))}
                        instanceId="status"
                        classNameWrapper={"w-full"}
                    />

                    <div className={"ml-1"}>
                        <InputCheckbox
                            id="tableMode"
                            label="Modo tabela"
                            checked={filters.tableMode}
                            onChange={(e) => setFilters(prev => ({...prev, tableMode: e.target.checked}))}
                        />
                    </div>

                </form>
            </div>
        </>
    );
};

export default Filters;